import { getUserData } from './API';
import { userTypes as typeOfUser } from '../constants/constants';
import { routeStore } from '../routes';
import category from '../routesCategory';
import reportsRoutes from '../components/Reports/routes';

const amiraIntent = {
  HOMEPAGE: 'homepage',
  NAVIGATION: 'navigation',

  //Slots VV
  ACTIVITIES: 'activities',
  BENCHMARK: 'benchmark',
  REPORTS: 'reports',
  TRACKING: 'track',
  PROGRESSMONITORING: 'progressmonitoring',
  DIAGNOSTIC: 'diagnostic',
  DYSLEXIA: 'dyslexiareport',
  PARENT: 'parent',
  //^^^
  //ADDACLASS: 'addaclass',
  //ADDASTUDENT: 'addastudent',
  //ASSIGNATEST: 'assignatest',
  //ASSIGNATESTTOCLASS: 'assignatesttoclass',
  //PLANNING: 'planning',
  //PRACTICEFREQUENCY: 'practicefrequency',
  //TRACK: 'track',
  //SCOREATEST: 'scoreatest',
  //PRINTATEST: 'printatest',
  //SENDEMAILTO: 'sendemailto',
  //SIGNIN: 'signin',
  //TEACHERSIGNOUT: 'teachersignout',
};

const blackList = [
  'infoaboutbenchmarks',
  'infoaboutnorms',
  'infoonorfreport'
];//Intents that don't trigger a redirect

const intentMapViews = {
  teacher: {
    [amiraIntent.HOMEPAGE]: category.teacher.DEFAULT,
    [amiraIntent.BENCHMARK]: category.teacher.BENCHMARK,
    [amiraIntent.TRACKING]: category.teacher.TRACKING,
    [amiraIntent.REPORTS]: category.teacher.REPORTS,
    [amiraIntent.ACTIVITIES]: category.teacher.ACTIVITIES,
    [amiraIntent.PROGRESSMONITORING]: category.teacher.PROGRESSMONITORING,
    [amiraIntent.DIAGNOSTIC]: category.teacher.DIAGNOSTIC,
    [amiraIntent.DYSLEXIA]: category.teacher.DYSLEXIA,
    [amiraIntent.PARENT]: category.teacher.PARENT,
    //[amiraIntent.ADDACLASS]: category.teacher.SIS,
    //[amiraIntent.ADDASTUDENT]: category.teacher.SIS,
    //[amiraIntent.ASSIGNATEST]: category.teacher.ASSIGNMENT,
    //[amiraIntent.ASSIGNATESTTOCLASS]: category.teacher.ASSIGNMENT,
    //[amiraIntent.PLANNING]: category.teacher.REPORTS,
    //[amiraIntent.PRACTICEFREQUENCY]: category.teacher.REPORTS,
    //[amiraIntent.TRACK]: category.teacher.REPORTS,
    //[amiraIntent.SCOREATEST]: category.teacher.GRADEBOOK,
    //[amiraIntent.PRINTATEST]: category.teacher.PRINT,
    //[amiraIntent.SENDEMAILTO]: category.teacher.EMAIL,
    //[amiraIntent.SIGNIN]: category.teacher.LOGIN,
    //[amiraIntent.TEACHERSIGNOUT]: category.teacher.LOGIN,
  },
  student: {
    //Add Students intent here and map it with their category/view
  }
};

function lookForRoutes(listOfRoutes, intentCategory){
  for(let route of listOfRoutes){
    if(intentCategory == route.category){
      console.log("Intent Manager - Found Route: ", route);
      return route;
    }
  }
  return null;
}

//Return the route associated with the data.IntentName.
//and match params with data.slots if necessary
function getAmiraRoute(data, userType){
  const intentName = data.intentName.toLowerCase();

  if(blackList.includes(intentName)){
    console.log("Intent Manager - Do not Redirect, intentName: ", intentName);
    return null;
  }

  //Redirect To Home Page
  if(intentName == amiraIntent.HOMEPAGE){
    return routeStore[userType].DEFAULT;
  }

  //Added for Navigation Intent on AmiraTeacher Bot
  if(intentName == amiraIntent.NAVIGATION && data.slots && data.slots.page){
    const category = data.slots.page;
    const navigation = lookForRoutes(routeStore[userType].routes, category) || lookForRoutes(reportsRoutes, category);
    return navigation.path;
  }

  let routeTo = null;
  const intentCategory = intentMapViews[userType][intentName];

  if(!intentCategory){
    console.warn("Intent Manager - Something went wrong with the Mapping");
    return null;
  }

  //Look for routes in the routeStore
  routeTo = lookForRoutes(routeStore[userType].routes, intentCategory);
  if(!routeTo){
    //Now look using the report's routes
    routeTo = lookForRoutes(reportsRoutes, intentCategory);
  }

  if(routeTo){
    //If we have a route and parameters are expected
    if(routeTo.matchRouteWithSlots){
      //construct the new route by calling the matchRouteWithSlots method of the route
      return routeTo.matchRouteWithSlots(data.slots);
    }
    //If route does not contain any parameters then return the route's path
    return routeTo.path;
  }

  console.warn("Intent Manager - Did not find Route");
  return null;
}

export function getRouteFromIntent(data){
  //consider doing this by botName (LexaTeacher and LexaStudent)
  switch(getUserData().userType){
    case typeOfUser.TEACHER:
      return getAmiraRoute(data, typeOfUser.TEACHER);
    case typeOfUser.STUDENT:
      return getAmiraRoute(data, typeOfUser.TEACHER);//TODO: Change this to typeOfUser.STUDENT when we separate Student and Teacher's routes
    default:
      console.warn("Invalid userType");
      return null;
  }
}